import Cookies from 'js-cookie'

const TokenKey = 'oauth-Token'
const RefreshToken = 'refresh-Token'


const Token = {
    getToken: function () {
        return Cookies.get(TokenKey)
    },
    setToken: function (token) {
        return Cookies.set(TokenKey, token)
    },
    removeToken: function () {
        return Cookies.remove(TokenKey)
    },
    getRefreshToken: function () {
        return Cookies.get(RefreshToken)
    },
    setRefreshToken: function (token) {
        return Cookies.set(RefreshToken, token)
    },
    removeRefreshToken: function () {
      return Cookies.remove(RefreshToken)
    },

}

export default Token